import { createContext, useContext, useEffect, useState } from "react";
import { api, BACKEND_URL } from "./api";

const CompanyContext = createContext(null);

const FALLBACK_LOGO = `${BACKEND_URL}/api/uploads/logo/mrs_logo.jpeg`;

export function CompanyProvider({ children }) {
  const [company, setCompany] = useState({ logo_url: "/api/uploads/logo/mrs_logo.jpeg", signature_url: "", name: "MRS Enterprise", address: "" });

  const refresh = async () => {
    try {
      const { data } = await api.get("/settings");
      setCompany(data);
    } catch { /* silently ignore — home page can render without auth */ }
  };

  useEffect(() => { refresh(); }, []);

  const logoSrc = company.logo_url ? `${BACKEND_URL}${company.logo_url}?t=${company.updated_at || ""}` : FALLBACK_LOGO;
  const signatureSrc = company.signature_url ? `${BACKEND_URL}${company.signature_url}` : "";

  return (
    <CompanyContext.Provider value={{ company, refresh, logoSrc, signatureSrc }}>
      {children}
    </CompanyContext.Provider>
  );
}

export const useCompany = () => useContext(CompanyContext);
